import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Alert, AlertDescription } from './ui/alert';

// The rules are the server's (platform/accounts/passwords.py); the page only checks the confirmation.
const PasswordForm = ({ currentLabel, submitLabel, onChanged }) => {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next !== confirm) {
      setError('Les deux mots de passe ne sont pas identiques.');
      return;
    }
    setSaving(true);
    try {
      const user = await changePassword(current, next);
      setCurrent('');
      setNext('');
      setConfirm('');
      onChanged(user);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Le mot de passe n\'a pas pu être changé.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      {error && (
        <Alert variant="destructive" data-testid="password-error">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <div className="space-y-2">
        <Label htmlFor="current-password">{currentLabel}</Label>
        <Input id="current-password" type="password" autoComplete="current-password" value={current}
          onChange={(e) => setCurrent(e.target.value)} required data-testid="password-current" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="new-password">Nouveau mot de passe (12 caractères ou plus)</Label>
        <Input id="new-password" type="password" autoComplete="new-password" value={next}
          onChange={(e) => setNext(e.target.value)} required data-testid="password-new" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="confirm-password">Confirmez le nouveau mot de passe</Label>
        <Input id="confirm-password" type="password" autoComplete="new-password" value={confirm}
          onChange={(e) => setConfirm(e.target.value)} required data-testid="password-confirm" />
      </div>
      <Button type="submit" className="btn-primary w-full" disabled={saving} data-testid="password-submit">
        {submitLabel}
      </Button>
    </form>
  );
};

export default PasswordForm;
